<soft-ds-button-group layout="spaced" size="sm" class="views">
  <soft-ds-button
    [variant]="view() === 'chart' ? 'primary' : 'outline'"
    data-testid="ai-agent-chart-view"
    (click)="view.set('chart')"
  >
    {{ '#AI_AGENT.CHART' | translate }}
  </soft-ds-button>
  <soft-ds-button
    [variant]="view() === 'table' ? 'primary' : 'outline'"
    data-testid="ai-agent-table-view"
    (click)="view.set('table')"
  >
    {{ '#AI_AGENT.TABLE' | translate }}
  </soft-ds-button>
</soft-ds-button-group>

@if (view() === 'chart') {
  <soft-chart class="chart" [config]="config()" />
} @else {
  <div class="table-scroll">
    <table class="table ds-body-2" data-testid="ai-agent-result-table">
      <thead>
        <tr>
          <th></th>
          <th class="numeric">{{ card().seriesLabel }}</th>
          @if (card().series2Label) {
            <th class="numeric">{{ card().series2Label }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track row.label) {
          <tr>
            <td>{{ row.label }}</td>
            <td class="numeric">{{ row.value | number: '1.0-2' }}</td>
            @if (card().series2Label) {
              <td class="numeric">{{ row.value2 | number: '1.0-2' }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
